<template>
  <header class="topbar">
    <div class="topbar-inner">
      <a class="brand" href="#/influencers" @click="closeMobile">
        <div class="brand-mark">
          <i class="bi bi-box" style="font-size:22px" aria-hidden="true"></i>
        </div>
        <div class="brand-text">
          <span class="brand-name">Indexer</span>
          <span class="brand-env" :class="'env-' + envBadge.tone">{{ envBadge.label }}</span>
        </div>
      </a>

      <button
        class="hamburger"
        :class="{ 'is-open': mobileOpen }"
        @click="mobileOpen = !mobileOpen"
        :aria-expanded="String(mobileOpen)"
        aria-label="Toggle menu"
      >
        <span></span><span></span><span></span>
      </button>

      <nav class="nav-links" :class="{ 'is-open': mobileOpen }">
        <a
          v-for="item in navItems"
          :key="item.key"
          :href="item.href"
          class="nav-link"
          :class="{ 'is-active': isActive(item) }"
          @click="closeMobile"
        >
          <i class="bi nav-icon" :class="item.icon" aria-hidden="true"></i>
          <span class="nav-label">{{ item.label }}</span>
        </a>
      </nav>

      <div class="topbar-actions" :class="{ 'is-open': mobileOpen }">
        <a class="btn btn-primary btn-new" href="#/influencer/new" @click="closeMobile">
          <i class="bi bi-plus-lg" aria-hidden="true"></i>
          <span>Add influencer</span>
        </a>
        <button class="logout-btn" @click="logout" title="Log out">
          <i class="bi bi-box-arrow-right" aria-hidden="true"></i>
          <span class="logout-label">Log out</span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>

  export default {
    name: "navigation",
    data() {
      return {
        mobileOpen: false,
        navItems: [
          {
            key: 'influencers',
            label: 'Influencers',
            href: '#/influencers',
            icon: 'bi-people-fill',
            matches: ['/influencers', '/influencer/new', '/influencer/edit', '/influencer/show']
          },
          {
            key: 'audience-ig',
            label: 'Instagram audiences',
            href: '#/audience/list',
            icon: 'bi-instagram',
            matches: ['/audience/list', '/audience/create']
          },
          {
            key: 'audience-tt',
            label: 'TikTok audiences',
            href: '#/audience/tiktok/list',
            icon: 'bi-tiktok',
            matches: ['/audience/tiktok']
          },
          {
            key: 'waiting',
            label: 'Pending profiles',
            href: '#/profile/waiting/list',
            icon: 'bi-hourglass-split',
            matches: ['/profile/waiting']
          },
          {
            key: 'registered',
            label: 'Registrations',
            href: '#/influencer/register/list',
            icon: 'bi-person-check-fill',
            matches: ['/influencer/register']
          }
        ]
      }
    },
    computed: {
      envBadge() {
        const h = (typeof location !== 'undefined' ? location.hostname : '') || '';
        if (h.indexOf('cz.influtool') !== -1) return { label: 'CZ', tone: 'cz' };
        if (h.indexOf('pl.influtool') !== -1) return { label: 'PL', tone: 'pl' };
        if (h.indexOf('anystar') !== -1) return { label: 'Anystar', tone: 'anystar' };
        if (h.indexOf('influtool.ovh') !== -1) return { label: 'DEV', tone: 'dev' };
        if (h === 'localhost' || h === '127.0.0.1' || h.indexOf('0.0.0.0') !== -1) return { label: 'LOCAL', tone: 'local' };
        return { label: 'PROD', tone: 'prod' };
      }
    },
    methods: {
      isActive(item) {
        const path = this.$route ? this.$route.path : '';
        return item.matches.some(m => path === m || path.indexOf(m + '/') === 0);
      },
      closeMobile() {
        this.mobileOpen = false;
      },
      logout() {
        this.$auth.destroyToken();
        this.closeMobile();
        if (this.$router) this.$router.push('/login');
      }
    }
  }
</script>

<style scoped>
  .topbar {
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: saturate(180%) blur(12px);
    -webkit-backdrop-filter: saturate(180%) blur(12px);
    border-bottom: 1px solid #e5e7eb;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  }
  .topbar-inner {
    max-width: 1280px;
    margin: 0 auto;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 24px;
  }

  .brand {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    flex-shrink: 0;
  }
  .brand-mark {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: linear-gradient(135deg, #265a88 0%, #3b82c4 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(38, 90, 136, 0.25);
  }
  .brand-text {
    display: flex;
    flex-direction: column;
    line-height: 1.1;
  }
  .brand-name {
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
  }
  .brand-env {
    margin-top: 2px;
    display: inline-block;
    font-size: 9.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    padding: 1px 6px;
    border-radius: 4px;
    width: fit-content;
  }
  .env-pl { background: #fee2e2; color: #991b1b; }
  .env-cz { background: #dbeafe; color: #1d4ed8; }
  .env-anystar { background: #f3e8ff; color: #6b21a8; }
  .env-dev { background: #fef3c7; color: #92400e; }
  .env-local { background: #f1f5f9; color: #475569; }
  .env-prod { background: #d1fae5; color: #065f46; }

  .hamburger {
    display: none;
    background: transparent;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    width: 40px;
    height: 36px;
    cursor: pointer;
    padding: 8px 9px;
    flex-direction: column;
    justify-content: space-between;
    margin-left: auto;
  }
  .hamburger span {
    display: block;
    height: 2px;
    background: #475569;
    border-radius: 2px;
    transition: transform 0.2s, opacity 0.2s;
  }
  .hamburger.is-open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
  .hamburger.is-open span:nth-child(2) { opacity: 0; }
  .hamburger.is-open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

  .nav-links {
    display: flex;
    align-items: center;
    gap: 2px;
    flex: 1;
  }
  .nav-link {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 7px 12px;
    border-radius: 8px;
    color: #475569;
    text-decoration: none;
    font-size: 13.5px;
    font-weight: 500;
    transition: background 0.15s, color 0.15s;
    position: relative;
  }
  .nav-link:hover {
    background: #f1f5f9;
    color: #0f172a;
  }
  .nav-link.is-active {
    background: #eaf1f9;
    color: #265a88;
    font-weight: 600;
  }
  .nav-icon {
    display: inline-flex;
    align-items: center;
    color: currentColor;
    opacity: 0.85;
  }
  .nav-link.is-active .nav-icon { opacity: 1; }

  .topbar-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
  .logout-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    border: 1px solid #e5e7eb;
    color: #475569;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 13.5px;
    font-weight: 500;
    line-height: 1.4;
    white-space: nowrap;
    cursor: pointer;
    transition: border-color 0.15s, color 0.15s, background 0.15s;
  }
  .logout-btn:hover {
    border-color: #dc2626;
    color: #dc2626;
    background: #fef2f2;
  }

  @media (max-width: 1024px) {
    .hamburger { display: flex; }
    .topbar-inner {
      flex-wrap: wrap;
      gap: 12px;
    }
    .nav-links, .topbar-actions {
      display: none;
      flex-basis: 100%;
      flex-direction: column;
      align-items: stretch;
      gap: 4px;
      order: 10;
    }
    .nav-links.is-open, .topbar-actions.is-open {
      display: flex;
    }
    .topbar-actions {
      order: 11;
      padding-top: 8px;
      border-top: 1px dashed #e5e7eb;
    }
    .nav-link {
      padding: 10px 12px;
      font-size: 14px;
      border-radius: 8px;
    }
    .btn-new, .logout-btn {
      justify-content: center;
      padding: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue